var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.74904V11.249C14.4996 11.3202 14.484 11.3905 14.4543 11.4552C14.4245 11.5198 14.3813 11.5774 14.3275 11.624C13.3725 12.4509 12.4594 12.749 11.5887 12.749C10.4069 12.749 9.30312 12.2028 8.27625 11.6959C6.61687 10.874 5.17438 10.1622 3.5 11.4847V14.249C3.5 14.3816 3.44732 14.5088 3.35355 14.6026C3.25979 14.6964 3.13261 14.749 3 14.749C2.86739 14.749 2.74021 14.6964 2.64645 14.6026C2.55268 14.5088 2.5 14.3816 2.5 14.249V3.74904C2.50048 3.67781 2.51617 3.6075 2.54603 3.54282C2.57589 3.47815 2.61922 3.4206 2.67313 3.37404C4.92313 1.42529 6.9425 2.42341 8.7225 3.30404C10.4375 4.15279 11.9244 4.88654 13.6725 3.37404C13.7448 3.3114 13.8335 3.2708 13.9281 3.25704C14.0227 3.24329 14.1193 3.25696 14.2064 3.29643C14.2935 3.3359 14.3674 3.39951 14.4195 3.47973C14.4715 3.55995 14.4995 3.65342 14.5 3.74904Z",
    fill: "#F98D23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewFlag);
export default __webpack_public_path__ + "static/media/review-flag.2aacb12fba2cbdbe3ce1f8ab32ea9322.svg";
export { ForwardRef as ReactComponent };